import React, { useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import moment from "moment";
import InputSelectForUetdsNotification from "../shared/input/special/InputSelectForUetdsNotification";
import { useDispatch } from "react-redux";
import { showModal } from "../../features/modal/modalSlice";
import { setSelectedUetdsNotification } from "../../features/admin4/admin4Slice";

const Container = styled.div`
  width: 100%;
    .main {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      position: relative;
      background-color: ${({ theme }) => theme.secondaryBgColor};
      margin: 0;
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(11, 1fr);
        text-align: center;
        align-items: center;
        gap: 15px;
        cursor: pointer;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
        }
      }
    }
`;

const AdminUetdsBildirimContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();

  return (
    <Container onClick={() => {dispatch(setSelectedUetdsNotification(data)); dispatch(showModal("uetdsControlUpdate"))}}>
        <div className="main"> 
          <div className="row">
            <div className="col">{moment(data.createdAt).format("DD.MM.YYYY HH:mm")}</div>
            <div className="col">{data.userName}</div>
            <div className="col">{data.phoneNumber}</div>
            <div className="col">{(data.distanceToLocation / 1000).toFixed(1)} km</div>
            <div className="col">{data.city}/{data.district}</div>
            <div className="col">{data.type}. Konum</div>
            <div className="col">{data.stationName}</div>
            <div className="col">{data.description}</div>
            <div className="col">{data.driverDescription}</div>
            {data.notificationStatus === 0 && <div className="col">İşlem Yapılmadı</div>}
            {data.notificationStatus === 1 && <div className="col">Evet</div>}
            {data.notificationStatus === 2 && <div className="col">Hayır</div>}
            <div className="col">{data.isDriverCalled ? "Arandı" : "Aranmadı"}</div>
          </div>
        </div>
    </Container>
  );
};

export default AdminUetdsBildirimContainer;
